import { Dialog, DialogContent, DialogTitle, MenuItem, Select, styled } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { translate } from '../../helper';
import i18n from '../../I18';

const LanguageSelectionWrapper = styled('div')(({ theme }) => ({
    '& .MuiInputBase-root': {
        'width': '100%'
    }
}));

const LanguageSelectionModal = ({ isOpen, onClose }) => {

    const [language, setLanguage] = React.useState('');

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
        >
            <DialogTitle sx={{fontSize: 'calc(var(--fs-xl)*0.943)',padding:'calc(var(--sp-md2)*1.5) calc(var(--sp-lg)*1.13)'}}>{translate('chooseLanguage')}</DialogTitle>
            <CloseIcon sx={{ fontSize: 'calc(var(--fs-sm)*2)',position: 'absolute',
                            right: 'calc(var(--sp-xxs)*2)',
                            top: 'calc(var(--sp-xxs)*2)',
                            color: '#000', 
                            cursor: 'pointer'
                        }}
                            onClick={onClose}                   
                        />
            <DialogContent style={{width: "calc(var(--fs-hero)*7.5)", padding:'calc(var(--fs-xl)*0.943) calc(var(--sp-lg)*1.13)'}}>
                <LanguageSelectionWrapper>
                    <Select
                        displayEmpty
                        sx={{
                            '& .MuiSelect-icon': {
                                width: 'calc(var(--sp-lg)*1.13)',
                                height: 'calc(var(--sp-lg)*1.13)',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                right: 'calc(var(--sp-xxs)*2)'
                            },
                            '& .MuiInputBase-input': { 
                                paddingRight: 'calc(var(--sp-lg)*2)',
                                lineHeight: 'calc(var(--sp-lg)*1.6)'
                            },
                            '& .MuiSelect-select': {
                                fontSize: 'var(--fs-md2)',
                                lineHeight: 'calc(var(--sp-lg)*1.6)',
                                paddingTop: 'calc(var(--sp-xxs)*2)',
                                paddingBottom: 'calc(var(--sp-xxs)*2)'
                            }
                        }}
                        onChange={(evt) => {
                            setTimeout(() => {
                                i18n.changeLanguage(evt.target.value, () => {
                                    window.location.reload();
                                });
                                setLanguage(evt.target.value);
                            }, 500);
                        }}
                        value={language}
                        id="languages"
                        renderValue={
                            language !== ''
                                ? undefined
                                : () => <span style={{ color: '#ababab', fontSize:'var(--fs-md2)' }}>{translate('selectLanguage')}</span>
                        }
                    >
                        <MenuItem value={'en'} sx={{ fontSize: 'var(--fs-md2)' }}>English</MenuItem>
                        <MenuItem value={'es'} sx={{ fontSize: 'var(--fs-md2)' }}>Spanish</MenuItem>
                    </Select>
                </LanguageSelectionWrapper>
            </DialogContent>
        </Dialog>
    );
};
export default LanguageSelectionModal;